// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_1t0nquPer5VsE8aGEPYvRT"};